export default {
    account: "Account",
    logout: "Logout",
    login: "Login",
    contrast: "High contrast",
    motion: "Reduced motion",
    findhelp: "Find help",
}